import React, { Fragment } from 'react';
import { defaultFormat } from '../../../Utils/DateFormat';
import { numberFormat, capitalize, formatPrice } from '../../../Utils/Common';
import Pagination from 'react-js-pagination';
import DynamicFont from 'react-dynamic-font';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';

export class BlitzDefaultContentCustom extends React.PureComponent {
    // function ReceivingPrintContent({ po_items, receivingData, deliveryDate, single_receiving, }) {
    constructor(props) {
        super(props);
        this.divScrollRef = React.createRef();

        let img_url = '/app-assets/images/logo/sample-logo.png';
        const tableRows = this.renderExtrRow(this.props.print_rows);
        let totalItemsCount = this.props.si_data.items.length;

        // Set itemsCountPerPage to 5 if the totalItemsCount is 7, 15, 23, or 31
        let itemsCountPerPage = [7, 15, 23, 31].includes(totalItemsCount)
            ? 6
            : 8;

        this.state = {
            auth: this.props.auth,
            si_data: this.props.si_data,
            activePage: 1,
            itemsCountPerPage: itemsCountPerPage,
            totalItemsCount: totalItemsCount,
            pageRangeDisplayed: 5,
            img_url: img_url,
            tableRows: tableRows,
            print: this.props.print,
            subs_setting: this.props.subs_setting,
        };
    }

    handlePageChange(pageNumber) {
        this.setState({ activePage: pageNumber });
        this.divScrollRef.current.scrollIntoView();
    }

    renderExtrRow(numberOfRows) {
        const tableRows = [];
        for (var i = 0; i < numberOfRows; i++) {
            tableRows.push(
                <tr key={`extra-${i}`}>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                </tr>
            );
        }

        return tableRows;
    }

    renderPrint(page, totalPage) {
        let auth = this.state.auth;
        let si_data = this.props.si_data;

        // console.log(si_data);

        let subId = '5fbce7782151301e660fa0d4';

        let img_url =
            auth.user.subscriber_id == subId
                ? '/monaki.png'
                : '/app-assets/images/logo/sample-logo.png';
        let company =
            auth.user.subscriber_id == subId ? 'Monikki Enterprises' : '';
        let address =
            auth.user.subscriber_id == subId
                ? '7i Bellagio 3 Forbestown Rd cor Burgos Circle BGC Taguig'
                : '';
        let contact = auth.user.subscriber_id == subId ? '02-7368-2071' : '';
        let email =
            auth.user.subscriber_id == subId
                ? 'mysecret.ph23@gmail.com.com'
                : '';

        let img_class =
            auth.user.subscriber_id == subId
                ? 'print-logo temp-logo'
                : 'print-logo';

        let temp_footer =
            auth.user.subscriber_id == subId ? (
                <div className="col-md-12">
                    <div className="f-14b pt-1 pb-2">
                        <div className="f-12">
                            {company} | {address} | {contact} | {email}{' '}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="col-md-6 col-print-6 ">
                    <ul className="f-16b ul-print-paw">
                        <li>Phone #</li>
                        <li>Address</li>
                        <li>Website</li>
                    </ul>
                </div>
            );

        // --- pagination bounds for this page (same logic as old template) ---
        const totalItemsCount = si_data.items.length;
        var showItemsToRaw = page * this.state.itemsCountPerPage;
        var showItemsFrom = showItemsToRaw - this.state.itemsCountPerPage;
        var showItemsTo = showItemsToRaw - 1;

        // Build the slice for this page only
        const visibleItems = si_data.items.slice(
            showItemsFrom,
            showItemsTo + 1
        );

        // Count how many filler rows are needed to keep uniform table height
        let extraRowsCount = this.state.itemsCountPerPage - visibleItems.length;
        if (extraRowsCount < 0) extraRowsCount = 0;

        const DynamicSkuStyle = {
            'max-width': '150px',
            fontSize: '1rem',
            lineHeight: '1.45',
            overflow: 'hidden',
            'text-decoration': 'underline',
        };

        const DynamicStringStyle = {
            // 'max-width': '150px',
            fontSize: '1rem',
            lineHeight: '1.45',
            overflow: 'hidden',
            'text-decoration': 'underline',
        };

        const customer = si_data.customer || {};
        const customerAddress = [
            si_data.customer.street1,
            si_data.customer.street2 && ', ',
            si_data.customer.street2,
            (si_data.customer.street1 || si_data.customer.street2) && ', ',
            si_data.customer.city,
            si_data.customer.city && si_data.customer.state && ', ',
            si_data.customer.state,
        ]
            .filter(Boolean)
            .join('');

        // const { company_name, company_address, company_landline, company_email } = this.props.si_data.subs_setting;

        // const customer_address = si_data.customer != null ? si_data.customer.street1 && si_data.customer.street1  + ', ' + si_data.customer.city && si_data.customer.city + ' ' + si_data.customer.country && si_data.customer.country.label : '';

        const template_setting = this.props.si_data.template_setting;

        const subs_setting = this.state.subs_setting;
        const currencyDisplay =
            subs_setting &&
            subs_setting.currency &&
            subs_setting.currency.code &&
            subs_setting.currency.code.checked
                ? 'code'
                : 'symbol';

        const dotMatrixStyle = {
            fontFamily: '"Courier New", Courier, monospace',
            fontSize: '16px',
            lineHeight: '1.2',
            whiteSpace: 'pre',
            padding: '20px',
        };

        const headerLineLength = this.props.print === '1' ? 100 : 80;
        const headerLine = Array(headerLineLength).fill('.').join('');

        return (
            <div
                className="dr-print"
                style={{
                    ...dotMatrixStyle,
                    // ensure each page breaks correctly when printing multiple pages
                    pageBreakAfter: page === totalPage ? 'auto' : 'always',
                }}
            >
                <div className="text-center">
                    *** ACKNOWLEDGEMENT RECEIPT ***
                </div>
                <div>{headerLine}</div>

                <div className="mt-2" style={{ fontSize: '18px' }}>
                    {si_data.template_setting?.company_name}
                </div>
                <div className="mt-1">
                    <strong>Delivered To:</strong>
                    {customer.name}
                </div>
                <div>
                    <strong>Address:</strong>
                    {customerAddress}
                </div>
                <div>
                    <strong>DR #:</strong> {si_data.delivery_receipt_no}
                </div>
                <div>
                    <strong>Reference #:</strong>{' '}
                    {si_data.sales_order_no || si_data.reference_no}
                </div>
                <div>
                    <strong>Delivery Date:</strong>{' '}
                    {si_data.delivery_date_string}
                </div>

                <Table
                    bordered={false}
                    size="sm"
                    className="mt-3"
                    style={{ borderCollapse: 'collapse' }}
                >
                    <thead
                        style={{
                            border: 'none',
                            borderBottom: '1px dotted #000',
                        }}
                    >
                        <tr>
                            <th className="p-1">SKU</th>
                            <th className="p-1">Product</th>
                            <th className="p-1 text-center">Qty</th>
                            <th className="p-1 text-center">Unit</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map((item, idx) => (
                            <tr key={showItemsFrom + idx}>
                                <td className="p-1">{item.sku}</td>
                                <td className="p-1">
                                    <DynamicFont
                                        content={item.product_name}
                                        style={DynamicStringStyle}
                                    />
                                    {item.barcode && (
                                        <>
                                            <br />
                                            <span className="f-10">
                                                {item.barcode}
                                            </span>
                                        </>
                                    )}
                                    {item.description && (
                                        <>
                                            <br />
                                            <span className="f-10">
                                                {item.description}
                                            </span>
                                        </>
                                    )}
                                    {item.brand && (
                                        <>
                                            <br />
                                            <span className="f-10">
                                                {item.brand}
                                            </span>
                                        </>
                                    )}
                                </td>
                                <td className="p-1 text-center">{item.qty}</td>
                                <td className="p-1 text-center">
                                    {item.product_unit_name}
                                </td>
                            </tr>
                        ))}
                        {this.renderExtrRow(extraRowsCount)}
                    </tbody>
                </Table>

                <div className="d-flex justify-content-end mt-3">
                    <div>Received Goods in good condition</div>
                </div>

                <div className="mt-2">
                    Prepared by : {si_data.user_prepared_by}
                </div>
                <div>Checked by : {si_data.user_checked_by}</div>
                <div>Approved by : {si_data.user_approved_by}</div>
            </div>
        );
    }

    renderMultiplePage() {
        const tableRows = [];
        const tableRowsTry = [];
        // keep using state for itemsCountPerPage,
        // but compute current total from props to avoid stale counts
        const totalItemsCountNow = this.props.si_data.items.length;
        let numberOfPage = Math.ceil(
            totalItemsCountNow / this.state.itemsCountPerPage
        );
        for (let i = 1; i <= numberOfPage; i++) {
            tableRows.push(this.renderPrint(i, Math.floor(numberOfPage)));
        }
        return tableRows;
    }

    render() {
        // console.log(this.state);
        const totalItemsCountNow = this.props.si_data.items.length;
        let numberOfPage = Math.ceil(
            totalItemsCountNow / this.state.itemsCountPerPage
        );

        return (
            <Fragment>
                {/*
                <div className="temp-watermark">
                    <h1>{si_data.status == 'draft' ? si_data.status : ''}</h1>
                </div>
            */}

                <div ref={this.divScrollRef} className="main-print-div">
                    {this.state.print == 0 ? (
                        this.renderPrint(this.state.activePage, numberOfPage)
                    ) : (
                        <Fragment>{this.renderMultiplePage()}</Fragment>
                    )}{' '}
                </div>

                <div className="hidden-print d-flex justify-content-center pagination-print">
                    <Pagination
                        className="pagination"
                        itemClass="page-item"
                        linkClass="page-link"
                        activePage={this.state.activePage}
                        itemsCountPerPage={this.state.itemsCountPerPage}
                        totalItemsCount={totalItemsCountNow}
                        pageRangeDisplayed={this.state.pageRangeDisplayed}
                        onChange={this.handlePageChange.bind(this)}
                    />
                </div>
            </Fragment>
        );
    }
}

export default BlitzDefaultContentCustom;
